import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthLoginUrl, getAuthCallbackUrl, getAuthClientId } from 'utils/config';
import { Button, StandalonePage } from 'design/ui';
import { radii } from 'design/tokens';

/** Generate a simple state for OAuth (optional, for CSRF). */
function randomState(): string {
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}

/**
 * Sign-in UI is deprecated. All auth is handled by the external auth service.
 * Redirects to auth UI with client_id and redirect_uri so after login the user is sent back with an auth code.
 */
const Login: React.FC = () => {
  const navigate = useNavigate();
  const [devToken, setDevToken] = useState('');
  const authBase = getAuthLoginUrl();

  const fullLoginUrl =
    authBase &&
    `${authBase.replace(/\/$/, '')}/login?${new URLSearchParams({
      client_id: getAuthClientId(),
      redirect_uri: getAuthCallbackUrl(),
      state: randomState(),
    }).toString()}`;

  useEffect(() => {
    if (fullLoginUrl) {
      window.location.href = fullLoginUrl;
    }
  }, [fullLoginUrl]);

  const handleDevLogin = () => {
    const token = devToken.trim();
    if (!token) return;
    navigate(`/auth/callback?token=${encodeURIComponent(token)}`, { replace: true });
  };

  if (fullLoginUrl) {
    return (
      <StandalonePage title="Taking you to sign in">
        <p style={{ margin: 0 }}>
          <a href={fullLoginUrl}>Continue to sign in</a> if nothing happens in a few seconds.
        </p>
      </StandalonePage>
    );
  }

  return (
    <StandalonePage title="Sign in">
      <p style={{ margin: 0 }}>
        Sign-in is handled by the auth service. Set <code className="st-code">REACT_APP_AUTH_LOGIN_URL</code> to its
        login URL and visitors are sent there automatically.
      </p>
      <p style={{ margin: 0 }}>
        For local development, run <code className="st-code">python3 scripts/security/dev_jwt.py</code> and paste the token
        below.
      </p>
      <textarea
        className="st-input"
        style={{ borderRadius: radii.lg, fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', resize: 'vertical' }}
        aria-label="Development token"
        placeholder="eyJ…"
        rows={3}
        value={devToken}
        onChange={(e) => setDevToken(e.target.value)}
      />
      <Button variant="primary" onClick={handleDevLogin} disabled={!devToken.trim()}>
        Sign in with this token
      </Button>
    </StandalonePage>
  );
};

export default Login;
